import { Component, Input, OnInit } from '@angular/core';
import { IDynamicComponentConfig } from '../../dynamic-component';

@Component({
  selector: 'app-fixed-display',
  templateUrl: './fixed-display.component.html',
  styles: [
    `
      .hasEerror {
        color: red;
      }
    `
  ]
})
export class FixedDisplayComponent implements OnInit {
  constructor() {}
  @Input() config: IDynamicComponentConfig;

  ngOnInit() {}
}
